import React, { useState, useEffect, useContext } from 'react';
import { AddBox } from '@mui/icons-material';
import { ModalGeneral, Tabla } from 'ui-component';
import headers from './Components/headers';
import MainCard from 'ui-component/cards/MainCard';
import LayautContext from 'Context/ContextLayaut';
import AvisoConfirmacion from 'ui-component/AvisoConfirmacion';
import ServiciosPlantilla from './Components/ServiciosPlantilla';
import FormPlantilla from './Components/FormPlantilla';
import ModalPreguntasPlantilla from './Components/ModalPreguntasPlantilla';
import { Button } from '@mui/material';

const Plantillas = ({ permisos }) => {
    const context = useContext(LayautContext);
    const serviciosPlantilla = ServiciosPlantilla();

    const [plantilla, setPlantilla] = useState([]);
    const [ctl, setCtl] = useState({ tiposMaterial: [] });
    const [modal, setModal] = useState({ open: false, titulo: '', width: 'md', component: <></>, cerrar: () => {} });
    const [confirm, setConfirm] = useState({ open: false });

    const actualizarData = (nuevaLista = []) => setPlantilla(nuevaLista);

    const abrirNuevaPlantilla = () => () => {
        context.formulario.abrir({
            open: true,
            width: 'sm',
            titulo: 'Nueva plantilla',
            propsForm: { data: null, ctl },
            formulario: FormPlantilla,
            aceptar: (dataForm) => {
                serviciosPlantilla.insertPlantilla((res) => {
                    actualizarData(res.plantillas);
                    context.formulario.cerrar();
                }, dataForm);
            }
        });
    };

    const abrirEditarPlantilla = (row) => {
        context.formulario.abrir({
            open: true,
            width: 'sm',
            titulo: `Editar plantilla ${row.titulo}`,
            propsForm: { data: row, ctl },
            formulario: FormPlantilla,
            aceptar: (dataForm) => {
                serviciosPlantilla.updatePlantilla(
                    (res) => {
                        actualizarData(res.plantillas);
                        context.formulario.cerrar();
                    },
                    { idPlantilla: row.idPlantilla, ...dataForm }
                );
            }
        });
    };

    const cambioEstatusPlantilla = (row) => () => {
        const nuevoEstatus = row.estatus == '1' ? 0 : 1;
        serviciosPlantilla.cambiarEstatusPlantilla((res) => actualizarData(res.plantillas), {
            idPlantilla: row.idPlantilla,
            estatus: nuevoEstatus
        });
    };

    const abrirEliminarPlantilla = (row) => {
        const texto = `¿Estás seguro de eliminar la plantilla "${row.titulo}"? No será considerada al crear nuevos materiales.`;

        setConfirm({
            open: true,
            text: texto,
            aceptar: () => {
                serviciosPlantilla.cambiarEstatusPlantilla(
                    (res) => {
                        actualizarData(res.plantillas);
                        setConfirm({ open: false });
                    },
                    { idPlantilla: row.idPlantilla, estatus: -1 }
                );
            }
        });
    };

    const cerrarModal = () => setModal({ open: false, titulo: '', width: 'md', component: <></>, cerrar: () => {} });

    const verPreguntas = (row) => {
        serviciosPlantilla.getPreguntasPlantilla(
            (res) => {
                setModal({
                    open: true,
                    titulo: `Preguntas de la plantilla "${row.titulo}"`,
                    width: 'lg',
                    component: (
                        <ModalPreguntasPlantilla
                            permisos={{ crear: true, editarPregunta: true, ...permisos }}
                            plantilla={{ ...row, preguntas: res.pregunta }}
                        />
                    ),
                    cerrar: cerrarModal
                });
            },
            { idPlantilla: row.idPlantilla }
        );
    };

    const acciones = [{ label: 'Nueva plantilla', icon: <AddBox />, click: abrirNuevaPlantilla }];
    const accionesFila = [
        { label: 'Editar', onClick: abrirEditarPlantilla, enabled: (row) => row.estatus == '1' },
        { label: 'Preguntas', onClick: verPreguntas, enabled: true },
        { label: 'Eliminar', onClick: abrirEliminarPlantilla, enabled: true }
    ];

    useEffect(() => {
        serviciosPlantilla.getPlantillasInt((res) => {
            setPlantilla(res.plantillas || []);
            setCtl({ tiposMaterial: res.tiposMaterial || [] });
        });
    }, []);

    return (
        <MainCard title="Plantillas">
            <Tabla
                rows={plantilla}
                columns={headers(cambioEstatusPlantilla).plantilla}
                accionesTabla={acciones}
                accionesFila={accionesFila}
                columnKey="idPlantilla"
            />
            <AvisoConfirmacion
                open={confirm.open}
                title="Advertencia"
                text={confirm.text}
                accept={confirm.aceptar}
                cancel={() => setConfirm({ open: false })}
            />
            <ModalGeneral
                open={modal.open}
                titulo={modal.titulo}
                width={modal.width}
                acciones={
                    <Button size="large" color="success" onClick={modal.cerrar}>
                        Cerrar
                    </Button>
                }
            >
                {modal.component}
            </ModalGeneral>
        </MainCard>
    );
};

export default Plantillas;
